<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled?'详情': bom.pkId > 0 ? '编辑' : '新建'"
      width="1100px"
      top="10vh"
      class="bom-edit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="bom"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <div style="font-size: 14px; margin-top: 10px">基本信息</div>
        <el-divider/>
        <el-col :span="12">
          <el-form-item label="类型" prop="bomType" style="margin-bottom: 13px">
            <el-select v-model="bom.bomType" placeholder="请选择类型" @change="bomTypeChange">
              <el-option label="销售BOM" :value="10"/>
              <el-option label="生产BOM" :value="20"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="bom.materialName" readonly placeholder="请选择物料">
              <el-button slot="append" @click="$refs.selectMaterial.open()"> 选择 </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编号">
            <el-input v-model="bom.materialNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位">
            <el-input v-model="bom.measuringUnitName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号">
            <el-input v-model="bom.bomNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="版本号">
            <el-input v-model="bom.versionNo" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div style="font-size: 14px; margin-top: 10px">子物料信息</div>
        <el-divider/>
        <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectChildMaterial.open()"> 添加 </el-button>
        <el-table 
            class="childMetrialTable" 
            :data="bom.bomDetails" 
            border
            :height="bom.bomDetails.length >= 10 ? '480' : ''">
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
              prop="materialNo"
              width="140"
              align="left"
              show-overflow-tooltip
              label="子物料编号"/>
          <el-table-column prop="specification" align="left" show-overflow-tooltip label="规格型号"/>
          <el-table-column prop="materialName" align="left" show-overflow-tooltip label="子物料名称"/>
          <el-table-column
              prop="measuringUnitName"
              align="center"
              width="80"
              show-overflow-tooltip
              label="单位">
            <template slot-scope="scope">
              <span v-if="scope.row.measuringUnitName">{{scope.row.measuringUnitName}}</span>
              <span v-else>PC</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" align="center" width="100" label="用量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quantity"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>

    <!-- 物料选择 -->
    <material-select ref="selectMaterial" @select="selectMaterial"/>
    <!-- 子物料选择 -->
    <material-child-select ref="selectChildMaterial" @select="selectChildMaterial"/>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import MaterialChildSelect from "@/views/information/Material/MaterialSelect";
  export default {
    name: "BomEdit",
    components: { MaterialSelect, MaterialChildSelect },
    data() {
      return {
        disabled:false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        bom: {
          pkId: 0,
          bomNo: "",
          materialName: "",
          materialNo: "",
          bomType: 10,
          versionNo: "",
          measuringUnitName: "",
          bomDetails: [],
        },
        ruleValidate: {
          bomType: { required: true, message: "请选择BOM类型", trigger: "change" },
          materialName: { required: true, message: "请选择物料", trigger: "change" },
        },
      };
    },
    methods: {
      open(row,disabled) { 
        this.dialogVisible = true;
        if (row) {
          this.bom.pkId = row.pkid;
          this.getBomInfoByID(row.pkid);
        }
        if(disabled) {
          this.disabled = true;
        }
      },

      // 根据物料id生成BOM编号和版本号
      getBomNoAndVersionNoByMaterialID() {
        this.$http.get("basic", `boms/bominfo?bomType=${this.bom.bomType}&materialId=${this.bom.materialID}`).then((resp) => {
          if (resp.success) {
            this.bom.bomNo = resp.data.bomNo;
            this.bom.versionNo = resp.data.versionNo;
          }
        });
      },

      // 切换类型
      bomTypeChange() {
        if (this.bom.materialName) {
          this.getBomNoAndVersionNoByMaterialID();
        }
      },

      // 选择物料
      selectMaterial(row) {
        this.bom.materialName = row.materialName;
        this.bom.materialNo = row.materialNO;
        this.bom.materialID = row.materialID;
        this.bom.measuringUnitName = row.measuringUnitName;
        this.getBomNoAndVersionNoByMaterialID();
      },

      // 选择子物料
      selectChildMaterial(row) {
        const result = this.bom.bomDetails.find((item) => row.materialID === item.partsId);
        if (result) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          const item = {
            partsId: row.materialID,
            materialName: row.materialName,
            materialNo: row.materialNO,
            measuringUnitName: row.unitName ? row.unitName : "PC",
            quantity: 0,
          };
          this.bom.bomDetails.push(item);
        }
      },

      // 根据BOMID查询详细信息
      getBomInfoByID(pkid) {
        this.$http.get("basic", `boms/${pkid}`).then((resp) => {
          if (resp.success) {
            this.bom = Object.assign(this.bom, resp.data);
            this.bom.materialID = resp.data.materialId;
          }
        });
      },

      // 删除选中的子物料
      deleteRow(index) {
        this.bom.bomDetails.splice(index, 1);
      },

      // submit
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.bom.bomDetails.forEach((item, index) => {
              item.rowIndex = index + 1;
            });
            this.submitLoading = true;
            this.$http
              .save("basic", "boms", this.bom)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.bom.pkId > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.bom-edit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.bom-edit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.bom-edit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.bom-edit .el-divider--horizontal {
  margin: 10px 0;
}

.bom-edit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.bom-edit .childMetrialTable .el-input__inner  {
  text-align: center;
}
</style>
